<template>
  <v-app-bar
    class="main-nav-bar mx-auto background"
    color="background"
    elevation="0"
    app
    absolute
    density="compact"
  >
    <router-link
      to="/"
      class="main-nav-logo-link"
    >
      <v-avatar
        v-if="$store.getters.authenticated"
        size="80"
        class="main-nav-logo text-blue-darken-3 mr-3"
      >
        <v-img
          :src="logoSrc"
          max-width="80"
          max-height="80"
          contain
        />
      </v-avatar>
    </router-link>

    <v-spacer />

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/"
      class="mx-3"
    >Dashboard</base-main-nav-btn>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/leads"
      class="mx-3"
    >Leads</base-main-nav-btn>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/commissions"
      class="mx-3"
    >Commissions</base-main-nav-btn>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/clicks"
      class="mx-3"
    >Clicks</base-main-nav-btn>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/payouts"
      class="mx-3"
    >Payouts</base-main-nav-btn>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/settings"
      class="mx-3"
    >Settings</base-main-nav-btn>

    <v-menu
      v-if="$store.getters.authenticated && switchableAccounts.length > 0"
      location="bottom"
    >
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          class="mx-2"
          size="small"
          variant="text"
        >
          <span class="account-switcher-label text-none">{{ currentAccountName }}</span>
          <v-icon
            end
            size="small"
          >mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list density="compact" min-width="220">
        <v-list-item
          v-for="account in switchableAccounts"
          :key="account.id"
          :active="Number(account.id) === Number(currentAccountId)"
          @click="onSwitchAccount(account.id)"
        >
          <v-list-item-title>{{ account.name }}</v-list-item-title>
          <v-list-item-subtitle>
            <span v-if="account.slug">{{ account.slug }}</span>
            <span v-if="account.slug && accountRoleLabel(account)"> · </span>
            <span v-if="accountRoleLabel(account)">{{ accountRoleLabel(account) }}</span>
          </v-list-item-subtitle>
          <template
            v-if="Number(account.id) === Number(currentAccountId)"
            #append
          >
            <v-icon size="small" color="primary">mdi-check</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

    <base-main-nav-btn
      v-if="$store.getters.isAdmin"
      to="/admin"
      class="mx-3"
    >Admin</base-main-nav-btn>

    <div v-if="$store.getters.authenticated">
      <v-tooltip v-if="$store.state.isDarkMode" location="bottom">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            size="small"
            icon
            @click="$store.dispatch('switchDarkMode', false)"
          >
            <v-icon
              size="small"
              color="yellow"
              class="mr-1"
            >mdi-moon-waxing-crescent</v-icon>
          </v-btn>
        </template>
        <span>Disable dark mode</span>
      </v-tooltip>
      <v-tooltip
        v-else
        location="bottom"
      >
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            size="small"
            icon
            @click="$store.dispatch('switchDarkMode', true)"
          >
            <v-icon
              size="small"
              color="yellow"
            >mdi-white-balance-sunny</v-icon>
          </v-btn>
        </template>
        <span>Enable dark mode</span>
      </v-tooltip>
    </div>

    <v-btn
      class="main-nav-btn mx-2"
      size="small"
      variant="text"
      v-if="!$store.getters.authenticated"
      :to="{ name: 'Login' }"
    >
      <v-icon
        class="mr-1"
        size="small"
      >mdi-login</v-icon>
      Login
    </v-btn>
    <v-btn
      class="mx-2"
      icon
      size="small"
      v-if="$store.getters.authenticated"
      @click="logoutConfirmation = true"
    >
      <v-icon size="small">mdi-logout</v-icon>
    </v-btn>
    <base-dialog-confirmation
      v-model="logoutConfirmation"
      prompt="Do you really want to logout?"
      confirm-text="Logout"
      confirm-color="red"
      @confirm="logout"
      @cancel="logoutConfirmation = false"
    />
  </v-app-bar>
</template>

<script>
import iconBlack from '@/assets/icon-black.png';
import iconWhite from '@/assets/icon-white.png';

export default {
  name: 'MainNav',

  data() {
    return {
      logoutConfirmation: false,
      iconBlack,
      iconWhite,
    };
  },

  computed: {
    logoSrc() {
      return this.$store.state.isDarkMode ? this.iconWhite : this.iconBlack;
    },
    switchableAccounts() {
      return this.$store.getters.switchableAccounts;
    },
    currentAccountId() {
      return this.$store.getters.currentAccountId;
    },
    currentAccountName() {
      const account = this.$store.getters.currentAccount;
      return account && account.name ? account.name : 'Account';
    },
  },

  methods: {
    logout() {
      this.$emit('logout');
    },

    accountRoleLabel(account) {
      if (!account) {
        return '';
      }
      if (account.role) {
        return account.role;
      }
      if (this.$store.getters.isPlatformAdmin) {
        return 'platform';
      }
      return '';
    },

    onSwitchAccount(accountId) {
      if (Number(accountId) === Number(this.currentAccountId)) {
        return;
      }
      this.$store.dispatch('switchAccount', accountId);
      const onAdmin = this.$route.path.startsWith('/admin');
      if (!onAdmin) {
        return;
      }
      if (!this.$store.getters.isAdmin) {
        this.$router.push('/');
        return;
      }
      this.$router.push('/admin');
    },
  },
};
</script>

<style lang="scss">
a:not(.clean):active,
a:not(.clean):hover {
  opacity: 0.8;
}

.account-switcher-label {
  display: inline-block;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>
